import React from 'react';
import type { Theme } from 'baseui';
import { useStyletron } from 'baseui';
import { StatefulTooltip } from 'baseui/tooltip';
const SHORTCUT_KEY_BACKGROUND = 'rgba(255, 255, 255, 0.2)';
export const tooltipOverrides = {
  Inner: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      paddingLeft: $theme.sizing.scale300,
      paddingRight: $theme.sizing.scale300
    })
  }
};
export const tooltipPopperOptions = {
  modifiers: {
    preventOverflow: {
      enabled: true,
      padding: 8
    }
  }
};
type ShortcutTooltipContentProps = {
  label: string;
  shortcutKeys: string[];
};
export const ShortcutTooltipContent = ({
  label,
  shortcutKeys
}: ShortcutTooltipContentProps) => {
  const [css, theme] = useStyletron();
  return <span className={css({
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.sizing.scale200
  })}>
      <span>{label}</span>
      {shortcutKeys.length > 0 && <span className={css({
      backgroundColor: SHORTCUT_KEY_BACKGROUND,
      borderRadius: theme.borders.radius100,
      padding: `0 ${theme.sizing.scale100}`
    })}>
          {shortcutKeys.join(' ')}
        </span>}
    </span>;
};
type ShortcutTooltipProps = {
  label: string;
  shortcutKeys: string[];
  children: React.ReactElement;
};
export const ShortcutTooltip = ({
  label,
  shortcutKeys,
  children
}: ShortcutTooltipProps) => {
  return <StatefulTooltip placement="bottom" showArrow overrides={tooltipOverrides} popperOptions={tooltipPopperOptions} content={() => <ShortcutTooltipContent label={label} shortcutKeys={shortcutKeys} />}>
      {children}
    </StatefulTooltip>;
};